export default __webpack_public_path__ + "static/media/megane-rs-gallery-4.99579793.jpg";